import { cn } from '@/lib/cn'
import type { HTMLAttributes } from 'react'

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('bf-skeleton h-4 w-full', className)} {...props} />
}
